import { SAVE_COURSE_INFO } from '@/actions/actionType';

const initialState = {
  courseActivityInstanceId: null,
  courseActivityId: null,
  status: null,
  nextMilestoneId: null,
  completedMilestones: [],
  milestoneConfigs: [],
  outline: null,
};

const courseActivityReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_COURSE_INFO: {
      const info = action.info || {};
      const mileStoneConfigs = info.mileStoneConfigs || info.milestoneConfigs || state.mileStoneConfigs || state.milestoneConfigs || [];
      const completedMilestones = info.completedMilestones || info.content?.completedMilestones || state.completedMilestones || [];
      return {
        ...state,
        ...info,
        mileStoneConfigs,
        milestoneConfigs: mileStoneConfigs,
        completedMilestones,
      };
    }
    default:
      return state;
  }
};

export default courseActivityReducer;
